function calculateEasterday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const n = h + l - 7 * m + 114;
  return new Date(year, Math.floor(n / 31) - 1, (n % 31) + 1);
}

function calculateHolidays(year) {
  const easter = calculateEasterday(year);
  const msDay = 24 * 60 * 60 * 1000;

  return [
    new Date(year, 0, 1),
    new Date(easter.getTime() - 3 * msDay), // Skærtorsdag
    new Date(easter.getTime() - 2 * msDay), // Langfredag
    easter,                                 // Påskedag
    new Date(easter.getTime() + 1 * msDay), // 2. Påskedag
    new Date(easter.getTime() + 39 * msDay),// Kristi Himmelfart
    new Date(easter.getTime() + 49 * msDay),// Pinsedag
    new Date(easter.getTime() + 50 * msDay),// 2. Pinsedag
    new Date(year, 5, 5),                   // Grundlovsdag
    new Date(year, 11, 24),                 // Juleaften
    new Date(year, 11, 25),                 // Juledag
    new Date(year, 11, 26),                 // 2. juledag
    new Date(year, 11, 31),                 // Nytårsaften
  ];
}

function isHoliday(date, holidays) {
  return holidays.some(
    (h) =>
      h.getDate() === date.getDate() &&
      h.getMonth() === date.getMonth() &&
      h.getFullYear() === date.getFullYear()
  );
}

document.addEventListener("DOMContentLoaded", function () {
  // ====== Section: Opening Hours & Holidays ======
  const openingHours = {
    monday: "10:00 - 18:00",
    tuesday: "10:00 - 18:00",
    wednesday: "10:00 - 18:00",
    thursday: "10:00 - 18:00",
    friday: "10:00 - 18:00",
    saturday: "09:00 - 14:00",
    sunday: "Lukket",
  };

  const weekdaysDanish = {
    monday: "Mandag",
    tuesday: "Tirsdag",
    wednesday: "Onsdag",
    thursday: "Torsdag",
    friday: "Fredag",
    saturday: "Lørdag",
    sunday: "Søndag",
  };

  const galleryText1 = document.querySelector('.store-gallery-text-1');
const galleryText2 = document.querySelector('.store-gallery-text-2');


  const today = new Date();
  const weekday = today.toLocaleDateString("en-US", { weekday: "long" }).toLowerCase();
  const holidays = calculateHolidays(today.getFullYear());

  let todayHours = isHoliday(today, holidays)
    ? "Lukket (Helligdag)"
    : openingHours[weekday];

  const todayOpening = document.getElementById("today-opening");
  if (todayOpening) {
    todayOpening.innerHTML = `Åbent i dag ${todayHours}`;
  }

const weekScheduleEl = document.getElementById("week-schedule");

if (weekScheduleEl) {
  weekScheduleEl.innerHTML = Object.entries(openingHours)
    .map(([day, hours]) => {
      const highlight = day === weekday ? " highlight-today" : "";
      return `<li class="opening${highlight}">${weekdaysDanish[day]}: <span>${hours}</span></li>`;
    })
    .join("");
}

  const toggle = document.getElementById("toggle-hours");
  if (toggle && weekScheduleEl) {
    toggle.addEventListener("click", () => {
      const isExpanded = weekScheduleEl.classList.contains("expanded");
      weekScheduleEl.classList.toggle("expanded", !isExpanded);
      toggle.classList.toggle("open", !isExpanded);
    });
  }

  // ====== Section: Store Switcher ======

  const buttons = document.querySelectorAll("#store-switcher button");
  const heading = document.getElementById("dynamic-heading");
  const description = document.getElementById("dynamic-description");
  const store1Section = document.getElementById("shopify-section-template--24600984912221__rich_text_EyBVQp");
  const store2Section = document.getElementById("shopify-section-template--24600984912221__rich_text_6GyptX");
  const addressElement = document.getElementById("store-address");
  const emailElement = document.getElementById("store-email");
  const emailLink = document.getElementById("store-email-link");
  const image1 = document.getElementById("store-image-1");
  const image2 = document.getElementById("store-image-2");
  const galleryStore1 = document.querySelector('.store-gallery-1');
  const galleryStore2 = document.querySelector('.store-gallery-2');

  const storeDetails = {
      store_1: {
      address: "Roskildevej 527, 2605 Brøndby ",
      email: "butik@heinocykler.dk",
    },
    store_2: {
      address: "Lyngbyvej 165, 2100 København",
      email: "2100@heinocykler.dk",
    },
  };

  function switchStore(store, newHeading, newDescription) {
    // Opdater tekst
    if (heading) heading.textContent = newHeading;
    if (description) description.textContent = newDescription;

    // Vis/skjul sektioner
    if (store1Section && store2Section) {
      store1Section.style.display = store === "store_1" ? "block" : "none";
      store2Section.style.display = store === "store_2" ? "block" : "none";
    }

    // Vis/skjul galleri
    if (galleryStore1 && galleryStore2) {
      galleryStore1.style.display = store === "store_1" ? "flex" : "none";
      galleryStore2.style.display = store === "store_2" ? "flex" : "none";
    }

    // Vis/skjul galleri-tekst
    if (galleryText1 && galleryText2) {
     galleryText1.style.display = store === "store_1" ? "block" : "none";
     galleryText2.style.display = store === "store_2" ? "block" : "none";
    }


// Opdater kontaktinfo
if (storeDetails[store]) {
  const { address, email } = storeDetails[store];
  
  if (addressElement) {
    addressElement.innerHTML = `<a href="https://www.google.com/maps?q=${address}" target="_blank">${address}</a>`;
  }

  if (emailLink) {
    emailLink.href = `mailto:${email}`;
    emailLink.textContent = email;
  }
}


    // Opdater billed-visning
    const isStore1 = store === "store_1";
    if (image1 && image2) {
      image1.classList.toggle("store-image-active", isStore1);
      image1.classList.toggle("store-image-inactive", !isStore1);
      image2.classList.toggle("store-image-active", !isStore1);
      image2.classList.toggle("store-image-inactive", isStore1);
    }
  }

let currentStore = "store_1"; 

if (buttons.length > 0) {
  buttons.forEach((btn) => {
    btn.addEventListener("click", function () {
      // Skift til den modsatte butik ved klik
      currentStore = currentStore === "store_1" ? "store_2" : "store_1";

      // Find den knap der matcher den nye butik
      const targetBtn = [...buttons].find(b => b.dataset.store === currentStore);

      switchStore(
        targetBtn.dataset.store,
        targetBtn.dataset.heading,
        targetBtn.dataset.description
      );
    });
  });
}

  // Klik på billeder
  [image1, image2].forEach((img) => {
    if (!img) return;
    img.addEventListener("click", function () {
      switchStore(this.dataset.store, this.dataset.heading, this.dataset.description);
    });
  });
});


const notice = document.getElementById('store-notice');

document.querySelectorAll('[data-store]').forEach(button => {
  button.addEventListener('click', () => {
    const store = button.dataset.store;

    if (store === 'store_1') {
      notice.classList.remove('hidden');
    } else {
      notice.classList.add('hidden');
    }
  });
});